import { createIcon } from "@chakra-ui/react"

export const NetworkWiredIcon = createIcon({
  displayName: "NetworkWiredIcon",
  viewBox: "0 0 20 20",
  path: (
    <path
      d="M12.5 3.5H7.5V6.5H12.5V3.5ZM7.5 2H12.5C13.3125 2 14 2.6875 14 3.5V6.5C14 7.34375 13.3125 8 12.5 8H10.75V9.25H19.25C19.6562 9.25 20 9.59375 20 10C20 10.4375 19.6562 10.75 19.25 10.75H15.75V12H17.5C18.3125 12 19 12.6875 19 13.5V16.5C19 17.3438 18.3125 18 17.5 18H12.5C11.6562 18 11 17.3438 11 16.5V13.5C11 12.6875 11.6562 12 12.5 12H14.25V10.75H5.75V12H7.5C8.3125 12 9 12.6875 9 13.5V16.5C9 17.3438 8.3125 18 7.5 18H2.5C1.65625 18 1 17.3438 1 16.5V13.5C1 12.6875 1.65625 12 2.5 12H4.25V10.75H0.75C0.3125 10.75 0 10.4375 0 10C0 9.59375 0.3125 9.25 0.75 9.25H9.25V8H7.5C6.65625 8 6 7.34375 6 6.5V3.5C6 2.6875 6.65625 2 7.5 2ZM2.5 13.5V16.5H7.5V13.5H2.5ZM17.5 13.5H12.5V16.5H17.5V13.5Z"
      fill="#667085"
    />
  ),
})
